import { connect } from 'react-redux';
import RegistrationComponent from '../components/RegistrationComponent';
import {
    updateProfile, getStatesIfNeeded, getCitiesIfNeeded,
    resetCities, getProfile, deleteProfile,
} from '../actions/ProfileActions';

/*
*This is the full registration form for editing the registration of the user (it is currently also the user profile screen)
*It is not the best name, but could not think of something better without refactoring everything....
*/

const mapStateToProps = (state) => ({
    isLoggedIn: !!state.profile.jwt,
    user: state.profile.user,
    submitting: state.profile.submitting,
    fetchingProfile: state.profile.fetchingProfile,
    states: state.profile.states,
    cities: state.profile.cities,
});

const mapDispatchToProps = (dispatch) => ({
    updateProfile: (user, password, passwordChanged) => {
        dispatch(updateProfile(user, password, passwordChanged));
    },
    getStatesIfNeeded: () => {
        dispatch(getStatesIfNeeded());
    },
    getCitiesIfNeeded: (stateId) => {
        dispatch(getCitiesIfNeeded(stateId));
    },
    resetCities: () => {
        dispatch(resetCities());
    },
    getProfile: () => {
        dispatch(getProfile());
    },
    deleteProfile: () => {
        dispatch(deleteProfile());
    },
});

const RegistrationContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(RegistrationComponent);

export default RegistrationContainer;
